import React from 'react';
import UsersTable from '../../shared/Tables/UsersTable';

class Users extends React.Component {

	render() {
		// console.log('Users: render');
		return (
			<div className="row">
			<div className="col-md-12">

				<h5>Utilisateurs</h5>
				<div className="card">
					<div className="card-header">
						<i className="fa fa-th-large"></i>
						Utilisateurs
					</div>

					<div className="card-block">
					<UsersTable history={this.props.history} type="0"/>
					</div>
				</div>
			</div>
			</div>
		);
	}
}

export default Users;